import {
  getMembershipStatusConfig,
  normalizeTierId,
} from './core/tierStyles'
import { useNavigation } from './shell/useNavigation'

export {
  getMembershipStatusConfig,
  normalizeTierId,
}

export function useUI() {
  return {
    navigation: useNavigation(),
  }
}
